import type { ReactNode } from 'react';
import classes from './Page.module.css';

export interface PageProps {
  /** 'narrow' 980px (form overview), default 1080px, 'wide' 1280px (two-pane inbox). */
  width?: 'narrow' | 'default' | 'wide';
  children: ReactNode;
}

/** The centred column every account screen sits in, sections 20px apart. */
export function Page({ width = 'default', children }: PageProps) {
  const cls = width === 'default' ? classes.page : `${classes.page} ${classes[width]}`;
  return <div className={cls}>{children}</div>;
}
